module.exports = __webpack_public_path__ + "img/37200.f858786d.jpg";